import { PriceMetadata } from "@convex/model/stripe";
import { z } from "zod";

export { PriceMetadata };

export type PriceMetadataKey = keyof z.infer<typeof PriceMetadata>;

/**
 * Product metadata schema for Stripe products.
 */
export const ProductMetadata = z.object({
  /** Comma-separated list of feature translation keys for i18n rendering */
  features: z.string().optional(),
});
